import { PaneArea } from '../../../types/shared'
import Rectangle, { IRectangleAttrs } from '../../canvas/rectangle'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = IRectangleAttrs
type PartialAttrs = Partial<Attrs>

class RectangleCreator extends Rectangle<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    const width = this.model.scale.x.width(35)
    const height = this.model.scale.y.height(35)
    this.attrs.x1 = startArea.x - width
    this.attrs.x2 = startArea.x + width
    this.attrs.y1 = startArea.y - height
    this.attrs.y2 = startArea.y + height

    setTimeout(() => {
      this.replaceMyself(Rectangle.fromObject<Rectangle>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default RectangleCreator
